import React, { useEffect, useState } from 'react'
import './index.css'
import './App.css'
import '@surveying-hub-bv/fe-component-library/dist/App.css'
import { ModalProvider } from '@surveying-hub-bv/fe-component-library'
import AuthProvider from './AuthProvider'
import { Analytics } from '@vercel/analytics/react'
import { LoginComponent } from './structure/Routing'
import { BrowserRouter } from 'react-router-dom'
import { useFavicon } from './utils/setFavicon'
import { branding } from './resources'
import { applyBrandColorsFromBranding } from './utils/applyBrandColorsFromBranding'
import { Suspense } from 'react';
import { useGoogleTagManager } from './utils/useGTM'
import { LoadingSpinner } from './components/LoadingSpinners'


// Not used yet, but can be used to toggle dark mode in the future.
// This has been hardcoded to dark mode as that allowed me to pre-emptively set up the dark mode as if light mode already existed.
export const useDarkMode = () => {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const root = window.document.documentElement;
    if (isDark) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [isDark]);

  return { isDark, toggle: () => setIsDark((prev) => !prev) };
};


const App: React.FC = () => {
  const descriptionBrandName = branding.brandName2nd ? `${branding.brandName} ${branding.brandName2nd}` : branding.brandName;

  useEffect(() => {
    applyBrandColorsFromBranding(branding);
  }, [descriptionBrandName]);

  useFavicon(branding.favicon);

  useInitializeDataLayer()

  useGoogleTagManager()

  return <>
    <React.StrictMode>
      <AuthProvider>
        <BrowserRouter>
          <ModalProvider>
            <Suspense fallback={<LoadingSpinner />}>
              <LoginComponent />
            </Suspense>
          </ModalProvider>
        </BrowserRouter>
      </AuthProvider>
    </React.StrictMode>
    <Analytics />
  </>
}
export default App

const useInitializeDataLayer = () => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || []
  }, [])
}
